<template>
  <div class="carWrap" style="height:100%;">
    <exportDate v-if="showExport" @hideExport="showExport = false" :toExportDetail="toExportDetail" :moduleName="detailModuleName" :roadCode="roadCode" />
    <div class="header">
      <TitleHeader @on-change-tab="onChangeTab" :tab="tab" />
      <div class="righth">
        <span class="demonstration">统计月份</span>
        <el-date-picker v-model="defaultTime" type="month" placeholder="选择月" @change="initData" value-format="yyyy-MM"></el-date-picker>
        <el-button style="margin-left:15px;" @click="goBack">返回上级</el-button>
        <el-button v-show="hideExport" style="margin-left:15px;" @click="showExport = true">导出</el-button>
      </div>
    </div>
    <main>
      <div class="table">
        <StopTable :allData="allData" v-if="tab == 0"></StopTable>
        <TimeTable :allData="allData" v-else></TimeTable>
      </div>
    </main>
  </div>
</template>
<script>
import StopTable from './components/stopTable' // 高速加油站停靠表格
import TimeTable from './components/timeTable' // 高速运营时段表格
import TitleHeader from '../components/titleHeader.vue' // 复用父组件tab切换
import http from '@/api/freight.js' //请求汇总
import Util from '@/utils/util'
import { hideExport } from '@/utils/tools'
import nameMixin from '../components/nameMixin'

export default {
  mixins: [nameMixin],
  components: {
    StopTable,
    TimeTable,
    TitleHeader,
  },
  props: {
    pTab: {
      type: [Number, String],
      default: 0,
    },
    pDefaultTime: {
      type: String,
      default: '',
    },
    pRoadCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      hideExport: hideExport,
      tab: 0, // 0 ->高速加油站 1 ->高速运营时段
      allData: [], // 总数据
      index: 1, // 当前页数
      defaultTime: '', //请求日期
      roadCode: '', //公路代码
      showExport: false, //控制批量导出
    }
  },
  mounted() {
    this.tab = this.pTab
    this.defaultTime = this.pDefaultTime
      ? `${this.pDefaultTime.substr(0, 4)}-${this.pDefaultTime.substr(4, 6)}`
      : Util.lastTime(new Date() * 1)
    this.roadCode = this.pRoadCode
    this.initData()
  },
  methods: {
    goBack() {
      this.$emit('on-close')
    },
    initData() {
      http
        .carOpeDetail({
          year: this.defaultTime.split('-')[0],
          roadCode: this.roadCode,
          month: this.defaultTime.split('-')[1],
          type: this.tab,
          moduleType: this.pRoadType,
        })
        .then((e) => {
          if (e.code == 200 && e.data) {
            this.allData = e.data
          } else {
            this.allData = []
          }
        })
    },
    onChangeTab(tabIndex) {
      this.tab = tabIndex
      this.initData()
      this.$emit('on-change-tab', tabIndex)
    },
    toExportDetail(yearMonths, reqId) {
      window.location.assign(
        http.carOpeDetailExport({
          yearMonths,
          reqId,
          type: this.tab,
          roadCode: this.roadCode,
          moduleType: this.pRoadType
        })
      )
    },
  },
}
</script>

<style lang='stylus'scoped>
active = #336db0;

.title {
  font-size: 18px;
  color: #999999;
  position: relative;

  &:first-child {
    margin-right: 40px;
  }

  &::after {
    content: '';
    display: block;
    height: 3px;
    position: absolute;
    bottom: -12px;
    left: 15%;
    width: 70%;
  }
}

.title.active {
  color: active;

  &::after {
    background: @color;
  }
}

.demonstration {
  color: #999;
  font-size: 18px;
  margin-right: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.carWrap {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
    display: flex;

    .table {
      flex: 1;
    }
  }
}

.block {
  display: flex;

  .center {
    margin: 10px auto;
  }
}
</style>

